import { IImageSet } from "@hopper-b2b/utilities";
import BookingConfirmation from "./client/Bunny-Confirmation-Default.png";
import ViBookingConfirmation from "./client/bunny-vi-confirmation.png";

export const lightModeImages: IImageSet = {
  flightBookingConfirmationImage: BookingConfirmation,
  ViBookingConfirmationImage: ViBookingConfirmation,
};
